module.exports = __webpack_public_path__ + "static/formations-0b6f8de6cae840665bc12eb475ba9ac9.jpg";